import { useState, useEffect, useRef } from 'react'

/**
 * Returns a persistent loading state for any given (async) fetchFunction
 * @param {func} fetchFunction
 * @param {array} refetchDependencies   - dependencies for useEffect
 * @param {number} [minTimeout=600]     - minimum time in ms for the loading state to return true
 * @returns {boolean}
 */
function useFetchData(fetchFunction, refetchDependencies, minTimeout = 600) {
    const [isLoading, setLoading] = useState(true)
    const isMounted = useRef(true)

    useEffect(() => {
        let isDone = false

        if (minTimeout > 0) {
            setTimeout(() => {
                if (isMounted.current && !isDone) {
                    setLoading(true)
                }
            }, minTimeout)
        } else if (isMounted.current && !isDone) {
            setLoading(true)
        }

        Promise.resolve(fetchFunction(refetchDependencies))
            .catch(console.error)
            .then(() => {
                if (isMounted.current) {
                    setLoading(false)
                    isDone = true
                }
            })
    }, [...refetchDependencies]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    return isLoading
}

export { useFetchData }
